import { Pages } from '@lib/types';
import { FlowType } from '@ace-clublabs/common-membership-api-types';

export interface PageNavigation {
  currentPage: Pages;
  nextPage?: Pages;
  previousPage?: Pages;
  overridePage?: Pages;
}

//Major rocket
const majorRocketPageNavigations: PageNavigation[] = [
  {
    currentPage: Pages.LandingPage,
    nextPage: Pages.BenefitsPage,
  },
  {
    currentPage: Pages.BenefitsPage,
    nextPage: Pages.ContactDetailsPage,
    previousPage: Pages.LandingPage,
  },
  {
    currentPage: Pages.ContactDetailsPage,
    nextPage: Pages.AutoCompleteResidenceAddressPage,
    previousPage: Pages.BenefitsPage,
  },
  {
    currentPage: Pages.AutoCompleteResidenceAddressPage,
    nextPage: Pages.BuildMembershipPage,
    previousPage: Pages.ContactDetailsPage,
  },
  {
    currentPage: Pages.AutoCompleteMailingAddressPage,
    nextPage: Pages.BuildMembershipPage,
    previousPage: Pages.AutoCompleteResidenceAddressPage,
  },
  {
    currentPage: Pages.ResidenceAddressPage,
    nextPage: Pages.BuildMembershipPage,
    previousPage: Pages.ContactDetailsPage,
  },
  {
    currentPage: Pages.MailingAddressPage,
    nextPage: Pages.BuildMembershipPage,
    previousPage: Pages.ResidenceAddressPage,
  },
  {
    currentPage: Pages.BuildMembershipPage,
    nextPage: Pages.ReviewPage,
    previousPage: Pages.AutoCompleteResidenceAddressPage,
  },
  {
    currentPage: Pages.ReviewPage,
    previousPage: Pages.BuildMembershipPage,
  },
];

//T-mobile
const tMobilePageNavigations: PageNavigation[] = [
  {
    currentPage: Pages.LandingPage,
    nextPage: Pages.BenefitsPage,
  },
  {
    currentPage: Pages.BenefitsPage,
    nextPage: Pages.ContactDetailsPage,
    previousPage: Pages.LandingPage,
  },
  {
    currentPage: Pages.ContactDetailsPage,
    nextPage: Pages.AutoCompleteResidenceAddressPage,
    previousPage: Pages.BenefitsPage,
  },
  {
    currentPage: Pages.AutoCompleteResidenceAddressPage,
    nextPage: Pages.BuildMembershipPage,
    previousPage: Pages.ContactDetailsPage,
  },
  {
    currentPage: Pages.AutoCompleteMailingAddressPage,
    nextPage: Pages.BuildMembershipPage,
    previousPage: Pages.AutoCompleteResidenceAddressPage,
  },
  {
    currentPage: Pages.ResidenceAddressPage,
    nextPage: Pages.BuildMembershipPage,
    previousPage: Pages.ContactDetailsPage,
  },
  {
    currentPage: Pages.MailingAddressPage,
    nextPage: Pages.BuildMembershipPage,
    previousPage: Pages.ResidenceAddressPage,
  },
  {
    currentPage: Pages.BuildMembershipPage,
    nextPage: Pages.ReviewPage,
    previousPage: Pages.AutoCompleteResidenceAddressPage,
  },
  {
    currentPage: Pages.ReviewPage,
    previousPage: Pages.BuildMembershipPage,
  },
];

//New Join
const newJoinPageNavigations: PageNavigation[] = [
  {
    currentPage: Pages.LandingPage,
    nextPage: Pages.BenefitsPage,
  },
  {
    currentPage: Pages.BenefitsPage,
    nextPage: Pages.ContactDetailsPage,
    previousPage: Pages.LandingPage,
  },
  {
    currentPage: Pages.ContactDetailsPage,
    nextPage: Pages.AutoCompleteResidenceAddressPage,
    previousPage: Pages.BenefitsPage,
  },
  {
    currentPage: Pages.AutoCompleteResidenceAddressPage,
    nextPage: Pages.BuildMembershipPage,
    previousPage: Pages.ContactDetailsPage,
  },
  {
    currentPage: Pages.AutoCompleteMailingAddressPage,
    nextPage: Pages.BuildMembershipPage,
    previousPage: Pages.AutoCompleteResidenceAddressPage,
  },
  {
    currentPage: Pages.ResidenceAddressPage,
    nextPage: Pages.BuildMembershipPage,
    previousPage: Pages.ContactDetailsPage,
  },
  {
    currentPage: Pages.MailingAddressPage,
    nextPage: Pages.BuildMembershipPage,
    previousPage: Pages.ResidenceAddressPage,
  },
  {
    currentPage: Pages.BuildMembershipPage,
    nextPage: Pages.ReviewPage,
    previousPage: Pages.AutoCompleteResidenceAddressPage,
  },
  {
    currentPage: Pages.ReviewPage,
    previousPage: Pages.BuildMembershipPage,
  },
];

//Gift
const giftPageNavigations: PageNavigation[] = [
  {
    currentPage: Pages.LandingPage,
    nextPage: Pages.BenefitsPage,
  },
  {
    currentPage: Pages.BenefitsPage,
    nextPage: Pages.DateSelector,
    previousPage: Pages.LandingPage,
  },
  {
    currentPage: Pages.DateSelector,
    nextPage: Pages.ContactDetailsPage,
    previousPage: Pages.BenefitsPage,
  },
  {
    currentPage: Pages.ContactDetailsPage,
    nextPage: Pages.AutoCompleteResidenceAddressPage,
    previousPage: Pages.DateSelector,
  },
  {
    currentPage: Pages.AutoCompleteResidenceAddressPage,
    nextPage: Pages.GiftDonorContactPage,
    previousPage: Pages.ContactDetailsPage,
  },
  {
    currentPage: Pages.AutoCompleteMailingAddressPage,
    nextPage: Pages.GiftDonorContactPage,
    previousPage: Pages.AutoCompleteResidenceAddressPage,
  },
  {
    currentPage: Pages.ResidenceAddressPage,
    nextPage: Pages.GiftDonorContactPage,
    previousPage: Pages.ContactDetailsPage,
  },
  {
    currentPage: Pages.MailingAddressPage,
    nextPage: Pages.GiftDonorContactPage,
    previousPage: Pages.ResidenceAddressPage,
  },
  {
    currentPage: Pages.GiftDonorContactPage,
    nextPage: Pages.GiftDonorAddressPage,
    previousPage: Pages.AutoCompleteResidenceAddressPage,
  },
  {
    currentPage: Pages.GiftDonorAddressPage,
    nextPage: Pages.SendMembershipCardPage,
    previousPage: Pages.GiftDonorContactPage,
  },
  {
    currentPage: Pages.SendMembershipCardPage,
    nextPage: Pages.SendGiftCardPage,
    previousPage: Pages.GiftDonorAddressPage,
  },
  {
    currentPage: Pages.SendGiftCardPage,
    nextPage: Pages.BuildMembershipPage,
    previousPage: Pages.SendMembershipCardPage,
  },
  {
    currentPage: Pages.BuildMembershipPage,
    nextPage: Pages.ReviewPage,
    previousPage: Pages.SendGiftCardPage,
  },
  {
    currentPage: Pages.ReviewPage,
    previousPage: Pages.BuildMembershipPage,
  },
];

const navigations: Partial<Record<FlowType, PageNavigation[]>> = {
  [FlowType.MAJOR_ROCKET]: majorRocketPageNavigations,
  [FlowType.B2B_MAJOR_ROCKET]: majorRocketPageNavigations,
  [FlowType.B2B_W_INSURANCE_AGENT]: majorRocketPageNavigations,
  [FlowType.GROUPON]: newJoinPageNavigations,
  [FlowType.NEW_JOIN]: newJoinPageNavigations,
  [FlowType.EMPLOYEE]: newJoinPageNavigations,
  [FlowType.T_MOBILE]: tMobilePageNavigations,
  [FlowType.GIFT]: giftPageNavigations,
  [FlowType.REJOIN]: newJoinPageNavigations,
};

export const getNextPage = (
  currentPage: Pages,
  flowType: FlowType | undefined | null,
  override: boolean = false
): Pages => {
  let nextPage: Pages = Pages.SorryPage;

  if (!flowType) {
    return nextPage;
  }

  const navigation = navigations[flowType];

  const pageNavigation = navigation?.filter((i) => i.currentPage === currentPage)[0];

  if (pageNavigation == null || pageNavigation.nextPage == null || (override && pageNavigation.overridePage == null))
    return nextPage;

  if (override && pageNavigation.overridePage != null && pageNavigation.overridePage != undefined)
    nextPage = pageNavigation.overridePage;
  else nextPage = pageNavigation.nextPage;

  return nextPage;
};

export const getPreviousPage = (
  currentPage: Pages,
  flowType: FlowType | undefined | null,
  override: boolean = false
): Pages => {
  let previousPage: Pages = Pages.SorryPage;

  if (!flowType) {
    return previousPage;
  }

  const navigation = navigations[flowType];

  const pageNavigation = navigation?.filter((i) => i.currentPage === currentPage)[0];

  if (
    pageNavigation == null ||
    pageNavigation.previousPage == null ||
    (override && pageNavigation.overridePage == null)
  )
    return previousPage;

  if (override && pageNavigation.overridePage != null && pageNavigation.overridePage != undefined)
    previousPage = pageNavigation.overridePage;
  else previousPage = pageNavigation.previousPage;

  return previousPage;
};
